import { ReactNode, useMemo } from 'react';

import { FeatureFlagsProvider, useBaseAuth } from '@cloudquery/base-users';

import isNonProductionEnvironment from './isNonProductionEnvironment';

interface Props {
  children: ReactNode;
}

// Defaulting to the LaunchDarkly Production Client ID for Platform when deployed
const LD_CLIENT_ID = isNonProductionEnvironment() ? undefined : '657068acb95b56102349695e';

export function PlatformFeatureFlagsProvider({ children }: Props) {
  const { user } = useBaseAuth();

  const customAttributes = useMemo(
    () => ({
      isCQInternal: user?.registered_team_internal,
      isPlatform: true,
    }),
    [user?.registered_team_internal],
  );

  return (
    <FeatureFlagsProvider
      clientIdOverride={LD_CLIENT_ID}
      customAttributes={customAttributes}
      teamNameOverride={user?.registered_team_name}
    >
      {children}
    </FeatureFlagsProvider>
  );
}
